import { ExtruderLevel, ProductStatus } from '@/enums'
import { useAuthStore } from '@/pinia/auth'
import { useCustomerStore } from '@/pinia/customer'
import { useStyleStore } from '@/pinia/style'
import { computed } from 'vue'

export function useAuthorisation() {
  const authStore = useAuthStore()
  const customerStore = useCustomerStore()
  const styleStore = useStyleStore()
  const customer = customerStore.customer?.customer
  const isLeadGen = styleStore.fabricator?.accountProductStatus === ProductStatus.LEAD_GEN_ONLY

  const isBase = computed(() => {
    const isExtruderBase = customer?.extruderLevel >= ExtruderLevel.BASE && authStore.isExtruder
    return isExtruderBase || !authStore.isExtruder
  })

  const isDesigner = computed(() => {
    const isExtruderDesigner = customer?.extruderLevel >= ExtruderLevel.DESIGNER && authStore.isExtruder
    return isExtruderDesigner || !authStore.isExtruder
  })

  const isReseller = computed(() => {
    const isExtruderReseller = customer?.extruderLevel >= ExtruderLevel.RESELLER && authStore.isExtruder
    return isExtruderReseller || (!isLeadGen && !authStore.isExtruder)
  })

  const isFabricator = computed(() => {
    const isExtruderFabricator = customer?.extruderLevel >= ExtruderLevel.FABRICATOR && authStore.isExtruder
    return isExtruderFabricator || (!isLeadGen && !authStore.isExtruder)
  })

  return {
    isBase,
    isDesigner,
    isReseller,
    isFabricator
  }
}
